import { makeStyles } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';

import { ConfirmDialog, StepsContainer } from '@roc/ui';
import { SendWireBaseStore } from '../stores';
import { SendWireFirstStep } from './sendWireFirstStep';
import { SendWireSecondStep } from './sendWireSecondStep';
import { useRocInternalPortalStore } from 'apps/roc-internal-portal/src/app/hooks';
import { isNil } from '@roc/feature-utils';

export const REJECTED = 'Rejected';
export const PENDING = 'Pending';
export const REQUEST_ERROR = 'Request Error';
export const WIRE_SENT = 'Wire Sent';
export const RECEIVED_BACK = 'Received Back';
export const WIRE_SETUP = 'Wire Setup';
export const PENDING_APPROVAL = 'Pending Approval';
export const ERROR_STATUSES = [PENDING, REQUEST_ERROR, REJECTED];


const useStyles = makeStyles(theme =>
  createStyles({
    stepper: {
      maxWidth: 800,
      margin: 'auto',
      alignContent: 'center',
      [theme.breakpoints.down('xs')]: {
        paddingLeft: theme.spacing(0.5),
        paddingRight: theme.spacing(0.5),
      },
    },
  })
);

interface SendWireStepperProps {
  store: SendWireBaseStore;
}

export const SendWireStepper = observer(({ afterActionExecuted = null }) => {

  const { sendWireInternalStore: store, drawStore } = useRocInternalPortalStore();
  const classes = useStyles();

  const getWireButtonText = () => {
    if (store?.wireInfo &&
      store?.wireInfo?.status === REJECTED &&
      !store?.wireInfo?.endToEndId) {
      return 'Override and Resend Wire';
    } else if (store?.wireInfo &&
      store?.wireInfo?.endToEndId &&
      [WIRE_SETUP, WIRE_SENT, REJECTED, PENDING_APPROVAL].includes(store?.wireInfo?.status)) {
      return "Mark as 'Received Back'";
    } else if (store?.wireInfo && store?.wireInfo?.endToEndId && RECEIVED_BACK === store?.wireInfo?.status) {
      return 'Send Duplicate Wire';
    } else {
      return 'Resend Wire';
    }
  }

  const isAllowNext = () => {
    if (store?.wireInfo) {
      return false;
    }
    return true;
  }

  const sendWireSteps = [
    {
      title: 'Wire Information',
      icon: null,
      onNext: () => {
        store.applyDQData();
      },
      allowBack: false,
      allowNext: true,
      nextButtonText: store.readOnlyMode ? 'Next' : 'Save and Continue',
    },
    {
      title: 'Review and Send Wire',
      icon: null,
      onBack: () => {
        store.goPrevStep();
      },
      onReject: () => {
        store.sendInterestPaymentWire();
      },
      onNext: () => handleConfirmSave(),
      allowBack: true,
      allowNext: isAllowNext(),
      nextButtonText: 'Send Wire',
      allowReject: true,
      rejectButtonText: 'Send Interest Payment Wire',
      allowReprice: !isNil(drawStore?.drawDTO?.draw?.wireId) && drawStore?.globalStore?.userFeatures?.drawsFeatureFlag && !isAllowNext(),
      repriceButtonText: getWireButtonText(),
      onReprice: () => handleWire(),
      showRepriceTooltip: false,
    }
  ];

  const handleConfirmSave = async () => {
    console.log("SEND WIRE")
    await store.sendWire();
    await afterActionExecuted && afterActionExecuted();
  };

  const handleWire = async () => {
    await store.handleWire();
    await afterActionExecuted && afterActionExecuted();
  };

  return (
    <>
      <StepsContainer
        disableNavigation={false}
        activeStep={store.activeStep}
        handleStep={step => store.moveToStep(step)}
        steps={sendWireSteps}
        stepperClassName={classes.stepper}
      >
        <SendWireFirstStep store={store} />
        <SendWireSecondStep store={store} />
      </StepsContainer>
      <ConfirmDialog
        open={store.isApplyDQConfirmDialogOpen}
        confirmButtonText='Confirm'
        handleClose={() => store.setIsApplyDQConfirmDialogOpen(false)}
        handleCancel={() => store.setIsApplyDQConfirmDialogOpen(false)}
        handleConfirm={() => store.applyDQData()}
        title={'Delinquent Crosscheck'}
        body={`Are you sure you want to save this DQ data?`}
      />
    </>
  );
});
